module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center container flex-column"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.zone.name) + " - " + _vm._s(_vm.currentBrand.name))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.name'),
      "required": true,
      "max-length": 99
    },
    model: {
      value: (_vm.zone.name),
      callback: function($$v) {
        _vm.zone.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "zone.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextInputBloc', {
    attrs: {
      "label": _vm.$t('zone.abbreviation'),
      "required": false,
      "max-length": 10
    },
    model: {
      value: (_vm.zone.abbreviation),
      callback: function($$v) {
        _vm.zone.abbreviation = $$v
      },
      expression: "zone.abbreviation"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextareaInputBloc', {
    attrs: {
      "label": _vm.$t('zone.description'),
      "required": false,
      "max-length": 1000
    },
    model: {
      value: (_vm.zone.description),
      callback: function($$v) {
        _vm.zone.description = $$v
      },
      expression: "zone.description"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('DefaultTextareaInputBloc', {
    attrs: {
      "label": _vm.$t('zone.refClient'),
      "required": false,
      "max-length": 100
    },
    model: {
      value: (_vm.zone.refClient),
      callback: function($$v) {
        _vm.zone.refClient = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "zone.refClient"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "inactiveColor": !_vm.isFormValidated,
      "background-color": _vm.currentBrand.linksColor,
      "disabled": !_vm.isFormValidated
    },
    on: {
      "click": function($event) {
        _vm.saveEditZone()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bebae02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/EditZone.vue
// module id = 3131
// module chunks = 0